import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sand/35 bg-forest-dark py-12 text-sand" data-id="element-14" data-mp="3gfsoch60l2p3">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-15" data-mp="32nummremu92y">
        <p className="font-serif text-xl font-bold text-white" data-id="element-16" data-mp="32pfgeet4hnzr">MEGAPACK BROMATOLOGÍA LISTO™</p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed" data-id="element-17" data-mp="36pzaf9iegbho">
          Hecho por especialistas, para docentes de Bromatología y Tecnología de Alimentos de toda Argentina.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm font-semibold leading-relaxed text-earth" data-id="element-18" data-mp="37fv17ktl04a">
          “La próxima clase que des, podés entrar al aula sabiendo que la Bromatología es la tecnología invisible que protege la salud de todos los argentinos.”
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-3" data-id="element-19" data-mp="29ynlrlrph7ej">
          <a href="mailto:packcentral23@gmail.com" className="inline-flex items-center gap-2 text-sm font-bold text-gold hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-20" data-mp="2eya1q2yx51r1">
            <MailIcon className="h-4 w-4" data-id="element-21" data-mp="3gapcfgy9ogex" /> packcentral23@gmail.com
          </a>
          <span className="inline-flex items-center gap-2 text-sm font-bold text-gold" data-id="element-22" data-mp="3gctpopi22rrv">
            <InstagramIcon className="h-4 w-4" data-id="element-23" data-mp="3v5n56axbv7wj" /> @centralpack.ar
          </span>
        </div>
        <p className="mt-8 border-t border-sand/20 pt-6 text-xs text-sand/55" data-id="element-24" data-mp="3q7bwi3irr3fw">
          © 2026 MEGAPACK BROMATOLOGÍA LISTO™ · Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}